export function wrapTextNodes(node) {
  // BR タグの場合は処理をスキップ
  if (node.nodeName === 'BR') {
    return;
  }

  if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
    const parent = node.parentNode;
    const text = node.textContent.split('').map(char => {
      // 半角スペースと全角スペースを &nbsp; に置き換え
      if (char === ' ' || char === '　') {
        const nbsp = document.createTextNode('\u00A0');
        const span = document.createElement('span');
        span.classList.add('letter');
        span.appendChild(nbsp);
        return span;
      }
      
      const span = document.createElement('span');
      span.classList.add('letter');
      span.textContent = char;
      return span;
    });
    
    text.forEach(span => parent.insertBefore(span, node));
    parent.removeChild(node);
  } else {
    // 子ノードに対して再帰的に処理を行う
    Array.from(node.childNodes).forEach(child => wrapTextNodes(child));
  }
}